

function Step(props) {
    

    return <div>
        <div className={`modal p-2 ${props.modal ? "fade show":""}`} style={{display: props.modal? 'block':'none'}} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered bd-example-modal-lg" role="document">
            <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">{props?.title}</h5>
                <button type="button" className="close closeButton customRadius" data-dismiss="modal" aria-label="Close" onClick={() => props.toggleModal(!props.modal)}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body p-0">
                {props.children}
            </div>
            </div>
        </div>
        </div>
        <div onClick={() => props.toggleModal(!props.modal)} className={`modal-backdrop ${props.modal ? "fade show":""}`}></div>
    </div>
}

export default Step